import { payerDomain } from '../../Common/constants';

export const aggregatorsUrl = `${payerDomain}/aggregators/`;

export const payersUrl = `${payerDomain}/payers/`;

export const dropDownDefault = [{ label: 'Please Select', value: '' }];
